<template>
  <el-dialog title="系统消息" :visible.sync="visible" :before-close="close" width="90%" hight="80%">
  <div>
    <Layout>
      <Card>
       <div class="content">
        <el-table :data="tableData" @row-click="itemClick">
          <el-table-column prop="id" align="center" minWidth="80" label="编号"></el-table-column>
          <el-table-column prop="birth" align="center" minWidth="200" label="标题"></el-table-column>
          <el-table-column prop="birth" align="center" minWidth="100" label="内容"></el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="tableparam.pagenum"
          :page-size="tableparam.pagesize"
          @current-change="handleCurrentChange"
          :total="tableparam.total"
        ></el-pagination>
        
      </div>
      </Card>

    </Layout>
  </div>
  </el-dialog>
</template>
<script>
import { api } from "@/request/api";
export default {
  props: ['visible','params'],
  components: {
    
  },
  data() {
    return {
      tableparam:{
        total: 10,
        pagenum: 1,
        pagesize: 5,
      },
      tableData: [],
      revamp: false,
      formLabelWidth: "100px",
    };
  },
  mounted(){

    
  },
  created() {
    var that=this;
    that.$watch('visible', function() {
        Object.assign(that.tableparam, that.params);
        if(that.visible){
          that.tableQuery();
        }
    });
  },
  methods: {
    close(){
      this.$emit("close");

    },
    itemClick(row){
      this.notificationCenter.postNotificationName('openSystemNewsListDialog',row);
    },
    tableQuery() {
      //列表
      var that = this;
      api.tableQuery(that.tableparam).then((response) => {
        response = response.data;
        if (response.code == 0) {
          that.total = response.page.totalCount;
          that.tableData = response.page.list;
        }
      });
    },
    handleCurrentChange(cpage) {
      //分页
      this.tableparam.pagenum = cpage;
      this.tableQuery();
    }
  },
};
</script>
<style lang="less" scoped="scoped">
.okButton
{
  margin-left:10px;
}
.search-box {
  display: flex;
  .add-btn {
    margin-right: 10px;
  }
}
.content img {
  width: 40px;
}
.newkhdn {
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-select {
    display: block;
  }

}
.table-action{
  display: flex;
  align-items: center;
  justify-content: center;
  
}
.table-action-item{
  
}
.table-action-item{
 position: relative;
 padding: 4px;
}
.table-action-item-pot{
  background: red;
    width: 4px;
    height: 4px;
    border-radius: 2px;
    position: absolute;
    top: 4px;
    right: 4px;
}
.search-select-wraper{
  display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
}
.search-select-title{
  width: 60px;
}
/deep/.el-dialog__body
{
  padding:0;
}
</style>
